<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card
        elevation="0"
    >
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialogForm" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text>
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <h3 class="font-weight-bold mb-5">{{ $t('buttons:add-specific', { specific: $t('common:facility')}) }}</h3>

              <!-- Dialog for copyying existing facility data -->
              <v-dialog v-model="copyFacilityDialog" width="600">
                <template v-slot:activator="{on, attrs }">
                  <v-btn
                      outlined
                      color="primary"
                      class="mb-4"
                      v-bind="attrs"
                      v-on="on"
                      >
                    {{ $t('book/facility:overview.form.copy-facility') }}
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title>
                    <h4 class="primary--text font-weight-bold">{{ $t('book/facility:overview.form.copy-dialog.title') }}</h4>
                  </v-card-title>

                  <v-card-text>
                    <v-row justify="center">
                      <v-col cols="12" md="10">
                        <v-select
                            outlined
                            v-model="facilityToCopy"
                            item-text="name"
                            item-value="id"
                            :menu-props="{ bottom: true, offsetY: true }"
                            :items="copyableFacilities"
                            :label="$t('common:facility')">
                        </v-select>
                      </v-col>
                    </v-row>

                  </v-card-text>

                  <v-card-actions class="pb-3 pr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      rounded
                      class="mr-2"
                      @click="copyFacility"
                    >
                      {{ $t('book/facility:overview.form.copy-dialog.copy-btn') }}
                    </v-btn>
                    <v-btn
                      color="grey"
                      class="white--text"
                      rounded
                      @click="closeCopyDialog"
                    >
                      {{ $t('buttons:cancel') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <h5 class="primary--text font-weight-medium">{{ $t('common:general') }}</h5>

                <!-- Name -->
                <DuplicateCheckField
                    ref="duplFacilityName"
                    :value="facility.name"
                    :label="$t('common:name')"
                    item-additional-info-field="objectNumber"
                    item-additional-info-field2="address"
                    required
                    tab-index="1"
                    item-text="name"
                    @input="facility.name = $event"
                    @checkForDuplicates="checkByFacilityName"
                    @clickedShowItem="showFacility"
                />

              <!-- Building -->
              <v-select
                  :items="restBuilding"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-model="facility.building"
                  outlined
                  :label="$t('common:building')"
                  clearable
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  @change="setBuildingLocation"
                  tabindex="2"
              />

              <v-row>
                <v-col>
                  <!-- Objectnumber -->
                  <DuplicateCheckField
                      ref="duplFacilityNumber"
                      :value="facility.objectNumber"
                      :label="$t('common:facility-number')"
                      item-additional-info-field="objectNumber"
                      item-additional-info-field2="address"
                      tab-index="3"
                      item-text="name"
                      @input="facility.objectNumber = $event"
                      @checkForDuplicates="checkByFacilityNumber"
                      @clickedShowItem="showFacility"
                  />
                </v-col>
                <v-col>
                  <!-- FacilityType -->
                  <v-select
                      :items="restFacilityTypes"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ bottom: true, offsetY: true }"
                      v-model="facility.type"
                      outlined
                      :label="$t('book/facility:common.facility-type')"
                      clearable
                      :rules="[ruleRequired($t('utils:rules.required'))]"
                      tabindex="4"
                  >
                    <template v-slot:item="{item}">
                      {{ item.name }}
                      <v-spacer></v-spacer>
                      <v-menu
                          open-on-hover
                          top
                          offset-x
                          max-width="300"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            icon
                          >
                            <v-icon>help_outline</v-icon>
                          </v-btn>
                        </template>


                        <v-list class="pa-0">
                          <v-list-item>
                            {{ item.description }}
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <!-- Stairway -->
              <v-text-field
                  outlined
                  v-model="facility.stairway"
                  :label="$t('book/facility:common.stairway')"
                  clearable
                  tabindex="5"
              />

              <!-- Manager -->
              <CustomerTypeahead v-if="isAdmin"
                  ref="managerTypeahead"
                  :value="facility.manager"
                  @input="facility.manager = $event"
                  :label="$t('book/facility:common.manager')"
                  tabindex="6"
                  required
              />
              <!-- Manager for non-admins: customer or sub-customer may be selected-->
              <v-select v-else
                  ref="managerSelect"
                  v-model="facility.manager"
                  :items="selectableCustomers"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ bottom: true, offsetY: true }"
                  outlined
                  :label="$t('book/facility:common.manager')"
                  clearable
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  tabindex="6"
              />
              <!-- public access flag -->
              <!--
              <v-checkbox
                  color="secondary"
                  v-model="facility.publicProcessAccess"
                  :label="$t('book/facility:common.public-access')"
              />
              -->

              <!-- TODO: Can be commented out once we have an official Sproof account -->
              <!-- Full service flag -->
              <v-checkbox
                  v-if="isAdmin"
                  color="secondary"
                  v-model="facility.fullService"
                  :label="$t('book/facility:common.full-service')"
              />

              <h4 v-if="isAdmin" class="primary--text font-weight-medium">{{
                  $t('book/facility:common.display')
                }}</h4>
              <!-- Building -->
              <v-select
                  v-if="isAdmin"
                  :items="restDisplay"
                  item-value="key"
                  item-text="value"
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-model="facility.displayId"
                  outlined
                  :label="$t('book/facility:common.display')"
                  clearable
                  tabindex="7"
              />

              <!-- QR-Code-Select -->
              <v-select
                  v-if="isAdmin"
                  :items="restQRCodes"
                  item-value="id"
                  item-text="name"
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-model="facility.qrcode"
                  outlined
                  :label="$t('common:qr-code_plural')"
                  clearable
                  tabindex="8"
              />

              <div class="mt-5">
                <BaseButton
                    color="primary"
                    :btnText="$t('buttons:add-specific', { specific: $t('common:facility')})"
                    @clickedButton="postFacilityDecision()"
                />

                <DirtyConfirmButtonDialog
                    ref="dirtyDialog"
                    :btn-text="$t('buttons:cancel')"
                    color="grey"
                    :dialog-title="$t('dialog:dirty-save-btn-title')"
                    :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="closeDialogForm"
                    :dataToWatch="facility"
                    hideOverlay
                />
                <EMailSendConfirmationDialog
                    ref="toggleButtonMessage"
                    color="errorDark"
                    :dialog-title="$t('book/facility:facility.form-sidebar.poa-dialog.btn-text')"
                    :dialog-text="$t('book/facility:facility.form-sidebar.poa-dialog.title')"
                    :button1-text="$t('buttons:cancel')"
                    :button2-text="$t('book/facility:facility.form-sidebar.poa-dialog.generate')"
                    @clickedButton2="postFacility()"
                    addTextField
                    :addTextFieldLabel="$t('common:email')"
                    :addTextFieldLastNameLabel="$t('book/facility:facility.form-sidebar.poa-dialog.label')"
                />

              </div>
            </v-col>
            <v-col cols="12" md="5" class="mt-12" align-self="center">
              <OpenStreetMap
                  ref="map"
                  :lat="lat"
                  :long="long"
                  height="400"
              ></OpenStreetMap>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template v-slot:activator="{on, attrs}">
      <v-btn rounded color="primary" elevation="0" v-bind="attrs" v-on="on">
        <v-icon>add</v-icon>
        <span class="d-none d-sm-flex">
          {{ $t('buttons:add-specific', { specific: $t('common:facility')}) }}
        </span>
      </v-btn>
    </template>
  </v-dialog>
</template>

<script>

import FacilityService from "@/modules/book/services/facility-service";
import BuildingService from "@/modules/book/services/building-service";
import CustomerService from "@/modules/core/services/customer-service";
import QRCodeService from "@/modules/book/services/qrcode-service";
import FacilityTypeService from "@/modules/book/services/facility-type-service";

import Utils from "@/modules/core/services/utils";
import DataUtils from "@/modules/core/services/data-utils";
import {ruleRequired} from "@/modules/core/services/rules";

import Facility from "@/modules/book/data/facility"
import Building from "@/modules/book/data/building";
import Customer from "@/modules/core/data/customer";
import QRCode from '@/modules/book/data/qrcode'
import FacilityType from '@/modules/book/data/facility-type';

import CustomerTypeahead from "@/modules/core/components/CustomerTypeAhead";
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";
import EMailSendConfirmationDialog from "@/modules/core/components/EMailSendConfirmationDialog/EMailSendConfirmationDialog";

import {mapGetters} from 'vuex';
import PdfGeneratorService from "@/modules/book/services/PdfGeneratorService";

import DuplicateCheckService from "@/modules/core/services/duplicate-check-service";
import DuplicateCheckField from "@/modules/core/components/DuplicateCheckField";

export default {
  name: 'FacilityDialogForm',
  components: {
    DuplicateCheckField,
    EMailSendConfirmationDialog,
    CustomerTypeahead,
    OpenStreetMap: () => import('@/modules/core/components/OpenStreetMap/OpenStreetMap'),
    DirtyConfirmButtonDialog,
    BaseButton
  },
  data() {
    return {
      restBuilding: [],
      restDisplay: [],
      restQRCodes: [],
      restFacilityTypes: [],

      facility: new Facility(),
      dialog: false,

      copyFacilityDialog: false,
      copyableFacilities: [],
      facilityToCopy: null,
      isCopying: false,
      lat: null,
      long: null,

      buildingIdFromURL: null,
      selectableCustomers: []
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    },
    ...mapGetters('auth', ['isAdmin']),
  },
  methods: {
    ruleRequired,
    createAndStorePDFDocument(facilityId) {

      if (this.facility.fullService && facilityId !== undefined) {
        let contactMail = this.$refs.toggleButtonMessage.textField;
        let contactName = this.$refs.toggleButtonMessage.textFieldLastName;

        PdfGeneratorService.createAndSignPOA(facilityId, contactMail, contactName,
            () => {
              this.closeDialogForm();
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:facility')}));
              this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${facilityId}`);
            },
            () => {
              this.closeDialogForm();
              Utils.showFailureSnackbar(this.$t('book/facility:overview.form.snackbar.createSignatureRequest-error'));
              this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${facilityId}`);
            }
        )
      }
    },
    openEMailPOADialog() {

      for(var i = 0; i < this.restBuilding.length; i++) {
        if (this.facility.building === this.restBuilding[i].id) {
          CustomerService.readFromAPI(this.restBuilding[i].operator,
              (res) => {
                var customer = DataUtils.parseDataToSingleObject(res.data, Customer);

                this.$refs.toggleButtonMessage.showDialog = true;
                this.$refs.toggleButtonMessage.textField = customer.contactMail;
                this.$refs.toggleButtonMessage.textFieldLastName = customer.contactName;
              },
              (error) => {
                this.$logger.info("Error at fetching specific customer: " + error);
                this.$router.push('/403');
              }
          )
        }
      }
    },
    postFacilityDecision() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.facility.fullService === true) {
        this.openEMailPOADialog();
      } else {
        this.postFacility();
      }
    },
    postFacility() {

      if (!this.edit && !this.isCopying) {
        FacilityService.postToAPI(this.facility,
          (res) => {
            var response = DataUtils.parseDataToSingleObject(res.data, Facility);

            if (this.facility.fullService) {
              this.createAndStorePDFDocument(response.id);
            } else {
              this.closeDialogForm();
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:facility')}));
              this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${response.id}`);
            }
          },
          () => {
            this.closeDialogForm();
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:facility')}))
          }
        )

      } else if(!this.edit && this.isCopying) {
        FacilityService.copyFacility(this.facility,
          (res) => {
            var response = DataUtils.parseDataToSingleObject(res.data, Facility);
            this.createAndStorePDFDocument(response.id);
            Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:facility')}));
            this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${response.id}`);
            this.closeDialogForm();
          },
          () => {
            this.closeDialogForm();
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:facility')}))
          }
        );

      }
    },
    closeDialogForm() {
      this.$refs.form.reset();
      this.lat = null;
      this.long = null;
      this.dialog = false;
    },
    setBuildingLocation() {
      for(var i = 0; i < this.restBuilding.length; i++) {
        if(this.facility.building === this.restBuilding[i].id) {
          this.lat = this.restBuilding[i].latitude;
          this.long = this.restBuilding[i].longitude;

          if (this.$refs.map) {
            this.$refs.map.refreshMap();
            this.$refs.map.recenterMap(this.lat, this.long)
          }
        }
      }
    },
    copyFacility() {
      for(var i = 0; i < this.copyableFacilities.length; i++) {
        if(this.copyableFacilities[i].id === this.facilityToCopy) {
          this.facility = this.copyableFacilities[i];
          this.facility.qrcode = null;
          this.facility.qrcodeName = null;
          break;
        }
      }
      this.copyFacilityDialog = false;
      this.facilityToCopy = null;
      this.isCopying = true;
    },

    closeCopyDialog() {
      this.copyFacilityDialog = false;
      this.facilityToCopy = null;
    },

    defineAddress(items) {
      items.forEach((item) => {
        item.address = item.buildingStreet + ", " + item.buildingZip + " " + item.buildingCity;
      })
    },

    checkByFacilityName(term) {
      DuplicateCheckService.checkFacilities('NAME', term,
          (res) => {
            this.defineAddress(res.data);
            this.$refs.duplFacilityName.fillData(res.data);
          },
          (serviceName, error) => {
            this.handleDuplicateErrorCause(serviceName, error);
          }
      )
    },

    checkByFacilityNumber(term) {
      DuplicateCheckService.checkFacilities('FACILITY_NUMBER', term,
          (res) => {
            this.defineAddress(res.data);
            this.$refs.duplFacilityNumber.fillData(res.data);
          },
          (serviceName, error) => {
            this.handleDuplicateErrorCause(serviceName, error);
          }
      )
    },

    showFacility(item) {
      window.open(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${item.id}#dashboard`);
    },

    handleDuplicateErrorCause(serviceName, error) {
      if (error.response.headers.error_cause && this.$t('error-causes:' + error.response.headers.error_cause)) {
        Utils.showWarningSnackbar(this.$t("error-causes:" + error.response.headers.error_cause));
      } else {
        this.$logger.error(serviceName + error);
      }
    },
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      })
    },

    dialog() {
      if(this.dialog) {

        //checks if url includes openForm=true and removes it so on refreshed dialog won't open again.
        if(this.$route.query.building || this.$route.query.openForm) {
          this.buildingIdFromURL = this.$route.query.building;
          this.$router.replace(`/${this.$store.state.manager.bookModuleUrl}/facilities`);
        }

        if (this.$refs.map) {
          this.$refs.map.refreshMap();
        }

        BuildingService.readAllFromAPI(
          (res) => {
            this.restBuilding = DataUtils.parseDataToObjectArray(res.data, Building);

            //load and set the default customer data to the customer fields
            if (!this.isAdmin) {
              CustomerService.readProfileFromAPI(
                  (resC) => {
                    let customer = DataUtils.parseDataToSingleObject(resC.data, Customer);
                    this.facility.manager = customer.id;
                    this.selectableCustomers = [ {id:customer.id, name:customer.name}];
                    this.selectableCustomers.push(...customer.descendants)
                    if(this.$refs.managerTypeahead) {
                      this.$refs.managerTypeahead.initialise(this.facility.manager);
                    }
                  },
                  (error) => {
                    Utils.showWarningSnackbar(this.$t('book/facility:overview.form.snackbar.customer-load-failure'))
                    this.$logger.error(error);
                  }
              )
            }

            //check if the user has buildinng query set and search for the right building
            if(this.buildingIdFromURL){
              for(var i = 0; i < this.restBuilding.length; i++) {
                if(this.restBuilding[i].id === this.buildingIdFromURL) {
                  this.facility.building = this.restBuilding[i].id;
                  this.setBuildingLocation();
                  break;
                }
              }
            }

            FacilityService.readAllPaginatedFromAPI(0, -1, '', ['name'], [false],
              (resp) => {
                this.copyableFacilities = resp.data.content;
              },
              (error) => {
                this.$logger.error("Error at fetching all facilities: " + error);
                Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:overview.form.snackbar.copy-facilities')}))
              }
            )

            FacilityTypeService.readAllFromAPI(
              (res) => {
                this.restFacilityTypes = DataUtils.parseDataToObjectArray(res.data, FacilityType);
              }
            )

            this.$refs.dirtyDialog.startWatch();
          },
          (error) => {
            this.$logger.error("Error at fetching all buildings: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:common.building-data')}))
          }
        )

        //admins may load and access display and QR code information
        if (this.isAdmin) {
          FacilityService.readDisplays(
            (res) => {
              this.restDisplay = res.data;
            },
            (error) => {
              this.$logger.error("Error at fetching displays: " + error);
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:common.display_plural')}))
            }
          )
          QRCodeService.readAllUnusedFromAPI(this.facility.id,
            (res) => {
              this.restQRCodes = DataUtils.parseDataToObjectArray(res.data, QRCode);
            },
            (error) => {
              this.$logger.error("Error at fetching QR-Codes: " + error);
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:qr-code_plural')}))
            }
          )
        }
      }
    }
  }
}
</script>
